import React, {useContext, useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {
    checkDot,
    getAuthHeader,
    getDateNumber,
    getExpensesTotal,
    getIncomesTotal, getLocalStorageItem,
    getMoneyMonthDetailPath,
    getMonthsNum, getPathAndQueryParams,
    objectLang,
    setErrorWindow, setGlobalMoneyObject, setLocalStorageItem, setMoneyMonthDetailPath
} from "../functions"
import {useHttp} from "../hooks/http.hook"
import config from "../config.json"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {MonthDetailClass} from "../components/MonthDetailClass"

export const MonthDetailPage = () => {
    setLocalStorageItem('page', 'MonthDetailPage')
    setMoneyMonthDetailPath(getPathAndQueryParams())
    const auth = useContext(AuthContext)
    const {loading, request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [expandIncome, setExpandIncome] = useState(false)
    const [expandExpense, setExpandExpense] = useState(false)
    const [preTotalInc, setPreTotalInc] = useState(0)
    const [preTotalExp, setPreTotalExp] = useState(0)
    const urlParams = new URLSearchParams(window.location.search)
    const month = urlParams.get('month')
    const year = urlParams.get('year')
    const calculation = urlParams.get('calculation')
    const lang = objectLang().language
    const l = lang.lang
    const globalMoneyObject = getLocalStorageItem('global-money-object')

    let monthNumStr
    if (getMonthsNum(month) > 9) {
        monthNumStr = String(getMonthsNum(month) + 1)
    } else {
        monthNumStr = `0${String(getMonthsNum(month) + 1)}`
    }

    globalMoneyObject['dataMonthGlobal'] = {
        nameYear: year,
        nameMonth: month,
        dateMonth: getDateNumber(`01.${monthNumStr}.${year}`),
        currency: globalMoneyObject['general']['settings']['currencies'][globalMoneyObject['general']['settings']['currency']],
        incomesMonthTotal: globalMoneyObject[year]['months'][month]['incomesMonthTotalPayment'],
        incomesMonthTotalPayment: globalMoneyObject[year]['months'][month]['incomesMonthTotalPayment'],
        incomesMonthTotalPurchase: globalMoneyObject[year]['months'][month]['incomesMonthTotalPurchase'],
        expensesMonthTotal: globalMoneyObject[year]['months'][month]['expensesMonthTotalPayment'],
        expensesMonthTotalPayment: globalMoneyObject[year]['months'][month]['expensesMonthTotalPayment'],
        expensesMonthTotalPurchase: globalMoneyObject[year]['months'][month]['expensesMonthTotalPurchase'],
        balanceMonth: globalMoneyObject[year]['months'][month]['balanceMonthPayment'],
        balanceMonthPayment: globalMoneyObject[year]['months'][month]['balanceMonthPayment'],
        balanceMonthPurchase: globalMoneyObject[year]['months'][month]['balanceMonthPurchase'],
        incomesOfNamesTotalsPayment: getIncomesTotal(globalMoneyObject[year]['months'][month]['income'], false),
        incomesOfNamesTotalsPurchase: getIncomesTotal(globalMoneyObject[year]['months'][month]['income'], false),
        expensesOfNamesTotalsPayment: getExpensesTotal(globalMoneyObject[year]['months'][month]['expensePayment'], 'payment', getMonthsNum(month), false),
        expensesOfNamesTotalsPurchase: getExpensesTotal(globalMoneyObject[year]['months'][month]['expensePurchase'], 'purchase', getMonthsNum(month), false),
        incomesAllFieldsPayment: getIncomesTotal(globalMoneyObject[year]['months'][month]['income'], true),
        incomesAllFieldsPurchase: getIncomesTotal(globalMoneyObject[year]['months'][month]['income'], true),
        expensesAllFieldsPayment: getExpensesTotal(globalMoneyObject[year]['months'][month]['expensePayment'], 'payment', getMonthsNum(month), true),
        expensesAllFieldsPurchase: getExpensesTotal(globalMoneyObject[year]['months'][month]['expensePurchase'], 'purchase', getMonthsNum(month), true),
        cards: globalMoneyObject['general']['settings']['cards']
    }

    setLocalStorageItem('global-money-object', globalMoneyObject)

    const updating = async (dataObject) => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/month/update`,
                'PUT',
                dataObject,
                {
                    Authorization: getAuthHeader(auth)
                })

            // if (data.code === 6041) {
            //     window.location.replace(getPathAndQueryParams())
            // }

            if (data.status === 200 && !data['changed']) {
                window.location.replace(getMoneyMonthDetailPath())
            }

            if (data.status === 200 && data['changed']) {
                setGlobalMoneyObject(data['money'])
                window.location.replace(getMoneyMonthDetailPath())
            }

        } catch (e) {
            window.location.replace(`/${l}/money/main`)
        }
    }

    const updateHandler = (data) => {

        const row = document.querySelector(`#${data['row']}`)
        const divDate = document.querySelector(`#${data['divDate']}`)
        const div = document.querySelector(`#${data['div']}`)
        const htmlCard = document.querySelector(`#${data['cardId']}`)
        const htmlName = document.querySelector(`#${data['name']}`)
        const htmlValue = document.querySelector(`#${data['value']}`)

        if (!htmlName || !htmlValue) {
            return
        }
        const name = htmlName.innerHTML
        const value = htmlValue.innerHTML.split(' ')[0]
        const divIconUpdate = document.querySelector(`#${data['divIconUpdate']}`)
        const divIconRemove = document.querySelector(`#${data['divIconRemove']}`)
        const htmlIconUpdate = document.querySelector(`#${data['iIconUpdate']}`)
        const inputName = document.createElement('input')
        const inputValue = document.createElement('input')
        inputValue.id = 'input-value'
        const sending = document.createElement('i')

        inputName.className = 'form-control'
        inputName.style.width = '70%'
        inputName.style.padding = '0.2rem 0.375rem'
        inputName.defaultValue = name
        inputValue.className = 'form-control'
        inputValue.style.width = '30%'
        inputValue.style.padding = '0.2rem 0.375rem'
        inputValue.defaultValue = value
        inputValue.autocomplete = 'off'
        inputValue.onchange = (e) => {checkDot(e)}
        sending.className = 'fa-regular fa-paper-plane d-flex align-items-center text-primary'
        divIconUpdate.classList.remove('d-none')
        divIconRemove.classList.add('d-none')
        divIconUpdate.append(sending)

        htmlCard.remove()
        htmlName.remove()
        htmlValue.remove()
        htmlIconUpdate.remove()
        divDate.classList.remove('justify-content-between')
        divDate.classList.add('justify-content-start')

        div.append(inputName)
        div.append(inputValue)
        row.append(divDate)
        row.append(div)
        row.append(divIconUpdate)
        row.append(divIconRemove)

        sending.onclick = () => {
            localStorage.removeItem('isTapUpdate')
            setLocalStorageItem('pathMonthDetail', getPathAndQueryParams())
            // setPathBack()
            updating({
                nameRecordDB: data['nameRecordDB'],
                nameYear: data['nameYear'],
                nameMonth: data['nameMonth'],
                purpose: data['purpose'],
                oldName: htmlName.innerHTML,
                oldValue: data['oldValue'],
                newName: inputName.value,
                newValue: Number(inputValue.value),
            }).then()
        }
    }

    const deleteHandler = (dataObject) => {
        setLocalStorageItem('pathBackRemoveLine', getPathAndQueryParams())
        setAllowed(false)
        setDataModal(setErrorWindow(lang.modal.warnings.title,
            '',
            lang.modal.warnings.desc.deleteOneMoneyLine,
            '',
            `replaceTo /${l}/money/month/remove-line?purpose=${dataObject['purpose']}&nameRecordDB=${dataObject['nameRecordDB']}`
        ))
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    return (
        <>
            <MonthDetailClass
                dataMonthGlobal={globalMoneyObject['dataMonthGlobal']}
                updateHandler={updateHandler}
                expandIncome={expandIncome}
                setExpandIncome={setExpandIncome}
                expandExpense={expandExpense}
                setExpandExpense={setExpandExpense}
                deleteHandler={deleteHandler}
                setPreTotalInc={setPreTotalInc}
                preTotalInc={preTotalInc}
                setPreTotalExp={setPreTotalExp}
                preTotalExp={preTotalExp}
                calculation={calculation}
            />
        </>
    )
}
